import {DEVTOOLS_FORCE_COOKIE} from "../constants";

const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

const getCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));

    return match ? decodeURIComponent(match[1]) : null;
};

const setForceCookie = (value: "1" | "0") => {
    document.cookie = `${DEVTOOLS_FORCE_COOKIE}=${value}; path=/; max-age=${COOKIE_MAX_AGE}`;
};

/**
 * Handles `?pgdevtools=1|0|true|false` URL search param by persisting it as a cookie,
 * then resolves whether devtools should be enabled based on cookie override or feature flag fallback.
 */
export const resolveDevtoolsEnabled = (featureFlagEnabled: boolean): {isEnabled: boolean; isForced: boolean} => {
    const params = new URLSearchParams(window.location.search);
    const devtoolsParam = params.get("pgdevtools");

    if (devtoolsParam === "1" || devtoolsParam === "true") {
        setForceCookie("1");
    } else if (devtoolsParam === "0" || devtoolsParam === "false") {
        setForceCookie("0");
    }

    const cookieValue = getCookie(DEVTOOLS_FORCE_COOKIE);
    // Cookie overrides env var when set: "1" forces ON, "0" forces OFF
    const isEnabled = cookieValue !== null ? cookieValue === "1" : featureFlagEnabled;
    const isForced = cookieValue === "1";

    return {isEnabled, isForced};
};
import {DEVTOOLS_FORCE_COOKIE} from "../constants";

const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

const getCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));

    return match ? decodeURIComponent(match[1]) : null;
};

const setForceCookie = (value: "1" | "0") => {
    document.cookie = `${DEVTOOLS_FORCE_COOKIE}=${value}; path=/; max-age=${COOKIE_MAX_AGE}`;
};

/**
 * Handles `?pgdevtools=1|0|true|false` URL search param by persisting it as a cookie,
 * then resolves whether devtools should be enabled based on cookie override or feature flag fallback.
 */
export const resolveDevtoolsEnabled = (featureFlagEnabled: boolean): {isEnabled: boolean; isForced: boolean} => {
    const params = new URLSearchParams(window.location.search);
    const devtoolsParam = params.get("pgdevtools");

    if (devtoolsParam === "1" || devtoolsParam === "true") {
        setForceCookie("1");
    } else if (devtoolsParam === "0" || devtoolsParam === "false") {
        setForceCookie("0");
    }

    const cookieValue = getCookie(DEVTOOLS_FORCE_COOKIE);
    // Cookie overrides env var when set: "1" forces ON, "0" forces OFF
    const isEnabled = cookieValue !== null ? cookieValue === "1" : featureFlagEnabled;
    const isForced = cookieValue === "1";

    return {isEnabled, isForced};
};
